var UitkActionListItemSpacingMap = [['standard', 'standard'], ['relaxed', 'relaxed']];
var UitkActionListItemSpacings = new Map(UitkActionListItemSpacingMap);
export { UitkActionListItemSpacings };